@if (isLoading) {
  <sd-skeleton
    [appearance]="SkeletonAppearanceEnum.line"
    [sizeChangeMobile]="false"
    [count]="1"
  />
} @else {
  @let pClass = isSmall ? horizontalParentLayout ? 'is-overline' : 'is-caption' : horizontalParentLayout ? 'is-overline' : 'is-body-s';
  <div #paragraph>
    <sd-html [innerClass]="'is-not-branded ' + pClass" [html]="text" />
    <sd-html innerClass="c__sold-by" [html]="textSoldBy" tag="div" />
  </div>
}
